<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>库存</el-breadcrumb-item>
      <el-breadcrumb-item>仓库设置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <!-- <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="产品分类" name="ItemCategory"></el-tab-pane>
        <el-tab-pane label="供应商" name="Supplier"></el-tab-pane>
        <el-tab-pane label="仓库" name="Stockroom"></el-tab-pane>
        <el-tab-pane label="零件库" name="Item"></el-tab-pane>
        <el-tab-pane label="设备库" name="Device"></el-tab-pane>
      </el-tabs>-->
      <component v-bind:is="currentTabComponent"></component>
    </div>
  </div>
</template>
<script>
import Stockroom from '@/views/store/_stockroom'

export default {
  components: {
    Stockroom
  },
  data() {
    return {
      currentTabComponent: Stockroom,
      activeName: 'Stockroom'
    }
  },
  methods: {
    handleTabClick(tab, event) {
      this.currentTabComponent = tab.name
    }
  }
}
</script>